"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
// capitalizes first character in a string
const capitalize = ramda_1.compose(ramda_1.join(''), ramda_1.juxt([
    ramda_1.o(ramda_1.toUpper, ramda_1.head),
    ramda_1.tail
]));
exports.default = capitalize;
